module.exports = __webpack_public_path__ + "static/media/200-point-player.6d4628cf.png";